import { Modal } from '@studiometa/ui';
import Panel from './Panel.js';

/**
 * Popin Newsletter class.
 */
export default class PopinNewsletter extends Modal {
  static config = {
    name: 'PopinNewsletter',
    refs: ['btnClose', 'input', 'widget', 'btn', 'close'],
    components: {
      Panel,
    },
    options: {
      delay: {
        type: Number,
        default: 7000,
      },
    },
  };

  /**
   * Mounted
   */
  mounted() {
    if (sessionStorage.getItem('newsletter_displayed')) {
      return;
    }

    setTimeout(() => {
      this.showPopin();
    }, this.$options.delay);
  }

  /**
   *
   */
  onBtnClick() {
    this.closeWidget();
    this.$el.classList.remove('pointer-events-none');
    this.$children.Panel[0].openPanel();
  }

  /**
   *
   */
  onPanelClosePanel() {
    this.$el.classList.add('pointer-events-none');
    this.$destroy();
  }

  /**
   *
   */
  onCloseClick() {
    this.closeWidget();
  }

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (this.opened && ESC) {
      this.closeWidget();
    }
  }

  /**
   * Close on click
   * @returns {void}
   */
  onBtnCloseClick() {
    this.closeWidget();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  showPopin() {
    this.opened = true;
    this.$refs.widget.classList.remove('translate-y-full', 'pointer-events-none');
  }

  /**
   * Close popin
   * @returns {void}
   */
  closeWidget() {
    sessionStorage.setItem('newsletter_displayed', true);
    this.opened = false;
    this.$refs.widget.classList.add('translate-y-full', 'pointer-events-none');
  }
}
